export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_WALLET_BALANCE = 'GET_ALL_WALLET_BALANCE'
export const GET_ALL_USER_CREDIT = 'GET_ALL_USER_CREDIT'
